import styled from 'styled-components';
import { DiGoogleAnalytics } from 'react-icons/di';


export const MainWrapper = styled.main`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1080px;
    margin: 80px auto;

    section {
        h1 {
            font-size: 46px;
            font-weight: 600;
            text-transform: capitalize;
            width: 400px;
            color: var(--black);
        }

        h2 {
            display: flex;
            align-items: center;
            margin-top: 20px;
            font-size: 24px;
            font-weight: 400;
        }

        p {
            color: var(--gray);
            font-size: 18px;
            width: 500px;
            margin-top: 20px;
            text-align: justify;
        }

        span {
            display: block;
            margin-left: 5px;
            font-weight: 100;
        }


    }

    figure {
        img {
            width: 500px;
        }
    }

    @media (max-width: 1150px) {
        justify-content: space-evenly;
        margin-top: 40px;
        margin: 80px auto;
        
        section {
            h1 {
                font-size: 36px;
                font-weight: 600;
                text-transform: capitalize;
                width: 300px;
                color: var(--black);
            }

        h2 {
            display: flex;
            align-items: center;
            margin-top: 20px;
            font-size: 18px;
            font-weight: 400;
        }

        p {
            color: var(--gray);
            font-size: 16px;
            width: 300px;
            margin-top: 20px;
            text-align: justify;
        }

        span {
            display: block;
            margin-left: 5px;
            font-weight: 100;
        }
    }

    figure {
        img {
            background-size: cover;
            height: 300px;
        }
    }
}

@media (max-width: 800px) {
    flex-wrap: wrap;

    figure {
        display:none;
    }
}

`;

export const Icon = styled(DiGoogleAnalytics)`
    color: var(--orange);
    font-size: 40px;
`